import { render, staticRenderFns } from "./Legislacao.vue?vue&type=template&id=4bb01d7b&"
import script from "./Legislacao.vue?vue&type=script&lang=js&"
export * from "./Legislacao.vue?vue&type=script&lang=js&"
import style0 from "./Legislacao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports